import contractPageHoc from '@nubank/www-latam-commons/hoc/contractPage';
import websitePage from 'hoc/websitePage/websitePage';

export default (Component, options) => (
  websitePage(options)(contractPageHoc(Component, options))
);
